import "@mittwald/flow-pro-icons";
import { autorunAppInitialization } from "../autorun/autorunAppInitialization";
import defaultLanguage from "../i18n/de";
import { lazyComponents } from "./implementations/all";
import widgetDOMClient from "./WidgetDOMClient";
import "regenerator-runtime";

autorunAppInitialization();

widgetDOMClient.renderWidgets(lazyComponents, {
  name: "widgets",
  defaultLanguage,
});
